module.exports = __webpack_public_path__ + "assets/18Plus-5c9a9d.webp";